import { css } from '@emotion/react';

import abcdRegular_woff2 from './fonts/ABCDiatypeRounded-Regular.woff2';
import abcdMedium_woff2 from './fonts/ABCDiatypeRounded-Medium.woff2';
import abcdBold_woff2 from './fonts/ABCDiatypeRounded-Bold.woff2';
import inclusiveSansRegular_tff from './fonts/InclusiveSans-Regular.ttf';
import inclusiveSansLight_tff from './fonts/InclusiveSans-Light.ttf';
import inclusiveSansMedium_tff from './fonts/InclusiveSans-Medium.ttf';
import inclusiveSansBold_tff from './fonts/InclusiveSans-Bold.ttf';

export const preloadFonts = [abcdRegular_woff2, inclusiveSansRegular_tff];

export const fonts = css`
  @font-face {
    font-family: 'ABC Diatype Rounded';
    src: url(${abcdRegular_woff2}) format('woff2');
    font-weight: 400;
    font-style: normal;
    font-display: fallback;
  }
  @font-face {
    font-family: 'ABC Diatype Rounded';
    src: url(${abcdMedium_woff2}) format('woff2');
    font-weight: 500;
    font-style: normal;
    font-display: fallback;
  }
  @font-face {
    font-family: 'ABC Diatype Rounded';
    src: url(${abcdBold_woff2}) format('woff2');
    font-weight: 700;
    font-style: normal;
    font-display: fallback;
  }
  @font-face {
    font-family: 'Inclusive Sans';
    src: url(${inclusiveSansLight_tff}) format('truetype');
    font-weight: 300;
    font-style: normal;
    font-display: fallback;
  }
  @font-face {
    font-family: 'Inclusive Sans';
    src: url(${inclusiveSansRegular_tff}) format('truetype');
    font-weight: 400;
    font-style: normal;
    font-display: fallback;
  }
  @font-face {
    font-family: 'Inclusive Sans';
    src: url(${inclusiveSansMedium_tff}) format('truetype');
    font-weight: 500;
    font-style: normal;
    font-display: fallback;
  }
  @font-face {
    font-family: 'Inclusive Sans';
    src: url(${inclusiveSansBold_tff}) format('truetype');
    font-weight: 700;
    font-style: normal;
    font-display: fallback;
  }
`;
